import React from 'react';
import Modal from './Modal';
import moment from 'moment';
import { ThomasCampaign } from 'models/interfaces/index';
import { Formik } from 'formik';
import { Form } from 'react-bootstrap';
import { StackedText, StackedDatePicker, StackedSelect } from '@tpco/blueprint-react';
import { printDate, iso8601 } from 'util/dateUtils';
import {
  p3CampaignNameVersionGenerator,
  listOfValidOptimizationDates
} from '@tpco/tpco-saturn-logic';
import { ApolloClient } from 'apollo-client';
interface P3CampaignZeroSumProps {
  isModalOpen: boolean;
  campaign: ThomasCampaign;
  formTitle: string;
  client: ApolloClient<any>;
  onClose: () => void;
  onSaveZeroSum: (values: any, client: ApolloClient<any>) => void;
}

const P3CampaignOptimization: React.FC<P3CampaignZeroSumProps> = ({
  isModalOpen,
  campaign,
  formTitle,
  client,
  onClose,
  onSaveZeroSum
}) => {
  const nameValidation = (value: string) => {
    if (!value) {
      return 'Required';
    }

    return null;
  };

  const composeSaveObject = (values: any) => {
    console.log('compose save object zero sum', iso8601(values.startDate));

    const saveObject = {
      startDate: iso8601(values.startDate),
      campaignId: campaign.campaign_id,
      name: values.name,
      tgramsId: campaign.tgrams_id
    };

    onSaveZeroSum(saveObject, client);
  };
  const validateDates = (value: any) => {
    const today = moment();
    const newStartDate = value;
    let message = '';
    console.log('today: ', today);
    console.log('startDate: ', moment(newStartDate));
    console.log('startDate: ', value);
    // newStartDate must be after today
    if (!moment(newStartDate).isAfter(today)) {
      message = 'Need a date in the future';
    }

    // newStartDate must be after currentStartDate
    if (!moment(newStartDate).isAfter(campaign.start_date)) {
      message = 'Need to start after the actual campaign started';
    }

    // newStartDate must be before currentEndDate
    if (!moment(newStartDate).isBefore(campaign.end_date)) {
      message = 'Need date before the actual campaign ended';
    }
    return message;
  };
  const validateStartDate = (value: any) => {
    let message = validateDates(value);
    return message === '' ? null : message;
  };

  const initialValues = {
    name: `${p3CampaignNameVersionGenerator(campaign.name)}`,
    startDate: new Date(printDate(campaign.start_date)),
    endDate: new Date(printDate(campaign.end_date))
  };

  return (
    <Modal
      onClose={onClose}
      isModalOpen={isModalOpen}
      el={document.createElement('div')}
      modalWidth="80%"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={values => composeSaveObject(values)}
        enableReinitialize={false}
      >
        {({ handleSubmit, values }) => (
          <Form className="card edit-campaign__container" onSubmit={handleSubmit}>
            <h4 className="edit-campaign__title">Optimize Campaign: {campaign.name}</h4>
            <p>
              You are attempting to optimize the current campaign for this company. This will create
              a new campaign record with a future start date. If you meant to edit the configuration
              attached to the current campaign please hit cancel, to close this window, and click
              the "Edit" icon (pencil) next to the current campaign and continue with your changes
              that way. If you did mean optimize the current campaign please click "Optimize" below
              and continue with your new campaign.
            </p>
            <StackedText
              htmlId="edit-p3-name"
              className="saturn-form-group saturn-col saturn-flex-column"
              fieldName="name"
              labelText="Name"
              validate={nameValidation}
              disabled={true}
            />
            {/* <StackedDatePicker
              className="edit-campaign__date"
              labelText="New Start Date"
              htmlId="edit-campaign-start-date"
              fieldName="startDate"
              validate={(value: any) => validateStartDate(value)}
            /> */}
            <StackedSelect
              htmlId="edit-campaign-start-date"
              className="saturn-form-group saturn-col saturn-flex-column"
              fieldName="startDate"
              labelText="New Start Date"
              disabled={false}
              onChange={validateStartDate}
              validate={validateStartDate}
              options={listOfValidOptimizationDates(campaign.start_date)}
            />
            <StackedDatePicker
              className="saturn-form-group saturn-col saturn-flex-columnedit-campaign__date"
              labelText="End Date"
              htmlId="edit-campaign-start-date"
              fieldName="endDate"
              disabled={true}
              // validate={(value: any) => validateEndDate(value, values)}
            />
            <div className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-columnedit-campaign__date">
              <div className="edit-campaign__submit">
                <button className="btn btn-primary" type="submit">
                  Optimize
                </button>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                <button type="button" className="btn btn-danger" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default P3CampaignOptimization;
